import { FC, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useAppSelector } from '../../store/hooks'
import { selectAuthenticatedUser } from '../../store/auth/authSlice'
import { ensureHotjarInitialized, setupHotjarUserAttributes, shouldEnableHotjarForUser } from './hotjarUtils'

export const HotjarBootstrap: FC = () => {
  const siteId = import.meta.env.REACT_APP_HOTJAR_SITE_ID
  const hjid = siteId ? Number(siteId) : null
  const user = useAppSelector(selectAuthenticatedUser)
  const eligibleUser = shouldEnableHotjarForUser(user) ? user : null
  const userId = eligibleUser?.id ?? null
  const accountId = eligibleUser?.accountId ?? null

  useEffect(() => {
    if (!hjid || !Number.isFinite(hjid)) {
      return
    }
    if (!userId || !accountId) {
      return
    }
    try {
      ensureHotjarInitialized(hjid)
      setupHotjarUserAttributes(userId, accountId)
    } catch (error) {
      Sentry.captureException(error)
    }
  }, [hjid, userId, accountId])

  return null
}
